import { render } from "./Detail.vue?vue&type=template&id=8d25b29a&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"

import "./Detail.vue?vue&type=style&index=0&id=8d25b29a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8d25b29a"

export default script